import {Skeleton, Box} from '@mui/material';

export default function AppSkeleton() {
  return (
    <Box>
      <Box mb={4}>
        <Skeleton variant="rectangular" width="100%" height="60px" sx={{mb: 2}} />
        <Skeleton variant="rectangular" width="100%" height="40px" sx={{mb: 2}} />
        <Skeleton variant="rectangular" width="100%" height="300px" sx={{mb: 2}} />
      </Box>
      <Box mb={4}>
        <Skeleton variant="rectangular" width="100%" height="60px" sx={{mb: 2}} />
        <Skeleton variant="rectangular" width="100%" height="40px" sx={{mb: 2}} />
        <Skeleton variant="rectangular" width="100%" height="300px" sx={{mb: 2}} />
      </Box>
      <Skeleton variant="rectangular" width="100%" height="80px" sx={{mb: 2}} />
    </Box>
  );
}
